import { render, staticRenderFns } from "./Ymc.vue?vue&type=template&id=311195f4&scoped=true"
import script from "./Ymc.vue?vue&type=script&lang=js"
export * from "./Ymc.vue?vue&type=script&lang=js"
import style0 from "./Ymc.vue?vue&type=style&index=0&id=311195f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311195f4",
  null
  
)

export default component.exports